import { QRSocial } from "./qr-social";
export { QRSocial };
